export default __webpack_public_path__ + "app/images/ic-16-message.svg";